import React, { createContext, useContext } from "react";
const AnalyticsContext = createContext(null);
export const AnalyticsProvider = ({ page, blade, uiLocation, children }) => {
    const parentProviderData = useContext(AnalyticsContext);
    const parentUiLocation = parentProviderData?.uiLocation;
    const contextValue = {
        page: page ?? parentProviderData?.page,
        blade: blade ?? parentProviderData?.blade,
        uiLocation: `${parentUiLocation ?? ""}${parentUiLocation && uiLocation ? "/" : ""}${uiLocation ?? ""}`,
    };
    return React.createElement(AnalyticsContext.Provider, { value: contextValue }, children);
};
export const useAnalytics = () => {
    const context = useContext(AnalyticsContext);
    if (!context) {
        return {
            page: undefined,
            blade: undefined,
            uiLocation: undefined,
        };
    }
    return context;
};
//# sourceMappingURL=AnalyticsProvider.js.map